/* file description */
/**
 * Textarea类型解析
 */
import React from 'react';
import { Input, Tooltip } from 'antd';
import { TextAutoFillValue } from '../component/TextAutoFillValue';
import { VALUE_TYPES, COLUMN_FROM } from './consts';
import { TransformNalmalType2TableColumn } from './type';
import { JsonTextareaMemo, JsonRender } from '../component/JsonTextarea';
import memo from '../component/memo';
import { TextMaxLength } from '@/const';
import { getPlaceHolder } from '../../common/utils';

const TextAreaMemo = memo(Input.TextArea);
const InputMemo = memo(Input);

export const transformText2TableColumn: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
}) => {
  targetColumn.valueType = VALUE_TYPES.TEXT;
  // targetColumn.copyable = false;
  const bizConfig = field?.bizConfig || {};
  const fieldName = field?.name ?? '';

  targetColumn.renderFormItem = (item, config) => {
    return <InputMemo placeholder={getPlaceHolder(field.label)} />;
  };

  if (bizConfig.json) {
    targetColumn.renderFormItem = (item, data) => {
      return <JsonTextareaMemo />;
    };
    targetColumn.render = (dom, entity) => {
      const value = entity?.value;
      return <JsonRender value={value} {...bizConfig.fieldProps} />;
    };
  } else {
    targetColumn.renderFormItem = (item, data) => {
      return <TextAreaMemo />;
    };
    targetColumn.render = (v, data) => {
      data?.setViewValue?.(v);
      return targetColumn.colProps?.span !== 24 && (v || '').length > TextMaxLength ? <Tooltip title={v}>{`${v.slice(0, TextMaxLength)}...`}</Tooltip> : v;
    };
  }

  // 获取自定义的组件和表单Item配置
  if (field?.bizConfig?.fieldProps) {
    targetColumn.fieldProps = field?.bizConfig?.fieldProps;
  }
  if (field?.bizConfig?.formItemProps) {
    targetColumn.formItemProps = field?.bizConfig?.formItemProps;
  }
  return targetColumn;
};
